export function ViewAllHintsShortcutsGroupSeparator() {
  return <div className="w-[300px] min-h-px bg-bar-border mb-3" />;
}
